<template>
    <b-form>
        <b-form-group id="comments-group" label="Comments" label-for="input-comments" label-cols="12" label-cols-md="3"
            label-class="font-weight-bold pt-0">
            <b-form-textarea type="text" id="input-comments" v-model="model.comments" required
                :placeholder="$translate('enter_comments')" rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>
        <div class="form-check">
            <label class="form-check-label ms-4 lh-base">
                <input type="checkbox" class="form-check-input top-2" id="input-completed" v-model="model.completed"
                    name="input-completed" :value="1" :unchecked-value="0" />
                {{ $translate('completed') }}
                <i class="input-helper"></i>
            </label>
        </div>
    </b-form>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-viewCheckoffForm',
    mixins: [permissionsMixins],
    data: () => ({
        model: {},
    }),
    props: ['value', 'status'],
    watch: {
        model: {
            handler: function (val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },
    mounted() {
        this.model = { ...this.value }
    },
}
</script>
